const PAGE_INDEX = 'page-home'; // INDEX
const PAGE_BLOG = 'page-blog-home'; // BLOG
const PAGE_FOR_VENDOR = 'page-for-vendor'; // FOR_VENDOR
const PAGE_COMPARE_SYSTEM = 'page-compare-system'; // COMPARE
const PAGE_COMPARE_SYSTEM_STATIC = 'page-compare-system-static'; // COMPARE SYSTEMS STATIC
const PAGE_CATEGORIES_COMPARE_SYSTEM = 'page-categories-compare-system'; // COMPARE_SYSTEMS
const PAGE_CATEGORIES = 'page-categories'; // CATEGORIES
const PAGE_SYSTEM_CATEGORIES = 'page-system-categories'; // SYSTEM_CATEGORIES
const PAGE_ABOUT_US = 'page-about-us'; // ABOUT_US
const PAGE_SYSTEMGUIDE = 'page-systemguide'; // SYSTEMGUIDE
const PAGE_SYSTEMGUIDE_RESULT = 'page-systemguide-result'; // SYSTEMGUIDE_RESULT
const PAGE_TOPLISTS = 'page-toplists'; // TOP_LISTS
const PAGE_LEGAL = 'page-legal'; // LEGAL
const PAGE_LEGAL_PRIVACY = 'page-legal-privacy'; // LEGAL_PRIVACY
const PAGE_LEGAL_TERMS = 'page-legal-terms'; // LEGAL_TERMS
const PAGE_LEGAL_COOKIE = 'page-legal-cookie'; // LEGAL_COOKIE
const PAGE_SYSTEM = 'page-system'; // SYSTEM (for URL / slugi18n)
const PAGE_FOUR_O_FOUR = 'page-four-o-four'; // 404
const PAGE_EMAIL_VERIFIED = 'page-email-verified';
const PAGE_SITEMAP_HTML = 'page-sitemap-html';
const PAGE_FINANCE_BUSINESS_LOAN = 'page-finance-business-loan';
const PAGE_SYSTEM_ALTERNATIVE = 'page-system-alternative';
const PAGE_INDUSTRY = 'page-industry';

const HUB_PAGE_HOME = 'hub-page-home';
const HUB_PAGE_ABOUT_US = 'hub-page-about-us';
const HUB_PAGE_CONTACT_US = 'hub-page-contact-us';
const HUB_PAGE_ARTICLE_LIST = 'hub-page-article-list';
const HUB_PAGE_ARTICLE = 'hub-page-article';

const STRAPI_SINGLE_PAGES = [
  PAGE_INDEX,
  PAGE_BLOG,
  PAGE_FOR_VENDOR,
  PAGE_COMPARE_SYSTEM,
  PAGE_COMPARE_SYSTEM_STATIC,
  PAGE_CATEGORIES_COMPARE_SYSTEM,
  PAGE_CATEGORIES,
  PAGE_SYSTEM_CATEGORIES,
  PAGE_ABOUT_US,
  PAGE_SYSTEMGUIDE,
  PAGE_SYSTEMGUIDE_RESULT,
  PAGE_TOPLISTS,
  PAGE_LEGAL,
  PAGE_LEGAL_PRIVACY,
  PAGE_LEGAL_TERMS,
  PAGE_LEGAL_COOKIE,
  PAGE_SYSTEM,
  PAGE_FOUR_O_FOUR,
  PAGE_EMAIL_VERIFIED,
  PAGE_SITEMAP_HTML,
  PAGE_FINANCE_BUSINESS_LOAN,
  PAGE_SYSTEM_ALTERNATIVE,
  PAGE_INDUSTRY,
  HUB_PAGE_HOME,
];

const getAllStrapiPageConstant = (pageConstant) => {
  const pageConstantArray = [...pageConstant];
  const dashIndexes = [...pageConstant.matchAll(new RegExp('-', 'gi'))].map(
    (a) => a.index
  );

  // First letter always uppercase
  pageConstantArray.splice(0, 1, pageConstantArray[0].toUpperCase());

  dashIndexes.forEach((dashIndex) => {
    const nextLetter = pageConstantArray[dashIndex + 1];

    pageConstantArray.splice(dashIndex + 1, 1, nextLetter.toUpperCase());
  });

  return `allStrapi${pageConstantArray.join('').replaceAll('-', '')}`;
};

const findStrapiLocalizedNode = (pageObject, strapiLocale) => {
  if (!pageObject || !pageObject.nodes || !strapiLocale) {
    return null;
  }

  return pageObject.nodes.find((pageNode) => pageNode.locale === strapiLocale);
};

const getStrapiPageObject = (strapiSinglePages, pageConstant, strapiLocale) => {
  if (!strapiSinglePages || !pageConstant || !strapiLocale) {
    return null;
  }

  const pageObject = strapiSinglePages[getAllStrapiPageConstant(pageConstant)];
  return findStrapiLocalizedNode(pageObject, strapiLocale);
};

module.exports = {
  STRAPI_SINGLE_PAGES,
  getStrapiPageObject,
  findStrapiLocalizedNode,
  getAllStrapiPageConstant,
  // Individual pages
  PAGE_INDEX,
  PAGE_BLOG,
  PAGE_FOR_VENDOR,
  PAGE_COMPARE_SYSTEM,
  PAGE_COMPARE_SYSTEM_STATIC,
  PAGE_CATEGORIES_COMPARE_SYSTEM,
  PAGE_CATEGORIES,
  PAGE_SYSTEM_CATEGORIES,
  PAGE_ABOUT_US,
  PAGE_SYSTEMGUIDE,
  PAGE_SYSTEMGUIDE_RESULT,
  PAGE_TOPLISTS,
  PAGE_LEGAL,
  PAGE_LEGAL_PRIVACY,
  PAGE_LEGAL_TERMS,
  PAGE_LEGAL_COOKIE,
  PAGE_SYSTEM,
  PAGE_FOUR_O_FOUR,
  PAGE_EMAIL_VERIFIED,
  PAGE_SITEMAP_HTML,
  PAGE_FINANCE_BUSINESS_LOAN,
  PAGE_SYSTEM_ALTERNATIVE,
  PAGE_INDUSTRY,
  HUB_PAGE_HOME,
  HUB_PAGE_ABOUT_US,
  HUB_PAGE_CONTACT_US,
  HUB_PAGE_ARTICLE_LIST,
  HUB_PAGE_ARTICLE,
};
